export const getLabelStyle = (type: string) => {
  let style = {
    'min-width': '65px',
    'box-sizing': 'border-box',
    'border-radius': '6px'
  };
  switch (type) {
    case 'int':
      style = {
        ...style,
        ...{
          background: '#E2F3FF',
          color: '#1E8BC3',
          border: '1px solid #1E8BC3'
        }
      };
      break;
    case 'float':
      style = {
        ...style,
        ...{
          background: '#FDF9EA',
          color: '#AA8F00',
          border: '1px solid #AA8F00'
        }
      };
      break;
    case 'date':
      style = {
        ...style,
        ...{
          background: '#DFF2F1',
          color: '#1BA39C',
          border: '1px solid #1BA39C'
        }
      };
      break;
    case 'string':
      style = {
        ...style,
        ...{
          background: '#FFF3E5',
          color: '#E65722',
          border: '1px solid #E65722'
        }
      };
      break;
    case 'geojson':
      style = {
        ...style,
        ...{
          background: '#E9E9FF',
          color: '#7462E0',
          border: '1px solid #7462E0'
        }
      };
      break;
    default:
      style = {
        ...style,
        ...{
          background: '#f8f8f8',
          color: '#123241',
          border: '1px solid #123241'
        }
      };
      break;
  }
  return style;
};
